import { render } from "./App.vue?vue&type=template&id=4277fca0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4277fca0&lang=less"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\0419\\ant-design-vue-pro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__